import React from "react";
import "./setBudget.css";
import { BudgetIncomeChart } from "./components/BudgetIncomeChart";
import { CreateBudget } from "./components/CreateBudget";
import { BudgetCategories } from "./components/BudgetCategories";
import NewLoader from "../../../../../../components/styled-components/loader/NewLoader";
export const SetBudget = ({
  transactions,
  budgetData,
  categoryBudget,
  filterData,
  categories,
  chartData,
  getChartData,
  clientTransactionsCategories,
  clientTransactionsSubCategories,
  updateTransactionsSubCategories,
  updateTransactionsCategories,
  loading,
  getAll,
}) => {
  return (
    <div>
      <div className="set-budget-container">
        <div className="budget-chart-card loader-conatiner-card">
          <BudgetIncomeChart chartData={chartData && chartData} />
          <NewLoader isLoading={loading} />
        </div>
        { localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client" &&  (<div className="budget-create-card loader-conatiner-card">
          <CreateBudget categories={categories && categories} chartData={chartData && chartData} getAll={getAll} />
          <NewLoader isLoading={loading} />
        </div>)}
        <div className="budget-categories-card loader-conatiner-card">
          <BudgetCategories
            categories={categories && categories}
            budgetData={budgetData && budgetData}
            getChartData={getChartData}
            clientTransactionsCategories={clientTransactionsCategories}
            clientTransactionsSubCategories={clientTransactionsSubCategories}
            updateTransactionsCategories={updateTransactionsCategories}
            updateTransactionsSubCategories={updateTransactionsSubCategories}
          />
          <NewLoader isLoading={loading} />
        </div>
      </div>
    </div>
  );
};
